import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { Provider as JotaiProvider } from 'jotai';
import { CssBaseline, IconButton, ThemeProvider } from '@mui/material';
import store from './store';
import theme from './theme/theme';
import TanstackQueryProvider from './provider/tanstack-query-provider';
import { SnackbarProvider } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

const router = createRouter({
  routeTree,
  trailingSlash: 'always',
  stringifySearch: (search) => {
    const params = new URLSearchParams();
    // search オブジェクトを URLSearchParams に変換
    Object.entries(search).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      params.set(key, String(value));
    });
    // 車両一覧ページのURLクエリのカンマをエンコードしないように置換
    const searchStr = params.toString().replace(/%2C/g, ',');
    return searchStr ? `?${searchStr}` : '';
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <JotaiProvider store={store}>
        <SnackbarProvider
          maxSnack={5}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          autoHideDuration={100000000}
          style={{
            width: 477,
          }}
          action={
            <IconButton size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          <TanstackQueryProvider>
            <CssBaseline />
            <RouterProvider router={router} />
          </TanstackQueryProvider>
        </SnackbarProvider>
      </JotaiProvider>
    </ThemeProvider>
  );
};

export default App;
